import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import cookie from '../utils/cookie.js';

import Home from './modules/Home.js'
import common from './modules/common.js'
import RemoteSensingMall from './modules/RemoteSensingMall.js'
import TradingHall from './modules/TradingHall.js'
import newsInfo from './modules/newsInfo.js'
import remoteSensingpedia from './modules/remoteSensingpedia.js'
import ResourceTools from './modules/ResourceTools.js'

import aboutUS from './modules/aboutUS.js'
import productSearch from './modules/productSearch.js'
import buyerCenter from './modules/buyerCenter.js'
import sellerCenter from './modules/sellerCenter.js'
import search from './modules/search.js'
import ReleaseRequirements from './modules/ReleaseRequirements.js'
import ConfirmPay from './modules/confirmPay.js'
import solution from './modules/solution.js'
import DemandList from './modules/DemandList'
import MoonSample from './modules/MoonSample.js'
import PDS from './modules/PDS.js'

import axios from 'axios';

Vue.use(Router)

const router = new Router({
  // base: '/dist',
  // mode: 'hash',//history
  mode: 'history',
  routes: [
    //   {
    //   path: '*',
    //   redirect: '/'
    // },
    ...Home,
    ...common,
    ...RemoteSensingMall,
    ...TradingHall,
    ...newsInfo,
    ...remoteSensingpedia,
    ...ResourceTools,
    ...aboutUS,
    ...productSearch,
    ...buyerCenter,
    ...sellerCenter,
    ...search,
    ...ReleaseRequirements,
    ...ConfirmPay,
    ...solution,
    ...DemandList,
    ...MoonSample,
    ...PDS,
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  }
})

router.beforeEach(async (to, from, next) => {
  console.log('路由信息：', to, from);

  console.log('before each invoked', store.state);
  // visitAdd this.$const.common.visitAdd  
  let res = await axios.post(`${window.dataManage.devPrefix}/client/visit`);
  // const loginUser = Object.keys(store.state.user.userInfo).length !== 0;
  let userToken = cookie.get('PIE_MALL_Token');
  // 判断路由是否设置相应校验用户权限
  if (to.meta.requireAuth) {
    if (!userToken) {
      if (from.name == null) {
        //此时，是在页面没有加载，直接在地址栏输入链接，进入需要登录验证的页面
        next("/");
        return;
      } else {
        // 没有登录，显示登录
        // debugger;
        // next(`/login?redirect=${to.fullPath}`)
        // location.href='https://www.cpeos.org.cn/personal/login/business?url='+window.location.href;
        location.href = window.dataManage.tianhuiLoginUrl + '?url=' + window.location.href;



      }
      // // 终止导航
      // next(false);
      // return;
    } else {
      // 有过登录token信息
      const promise = store.dispatch('user/getUserINFO')
      promise.then(res => {
        let nestStaus = store.state.user.isLogin;
        if (nestStaus) {
          next();
        } else {
          // debugger;
          // next(`/login?redirect=${to.fullPath}`)
          // location.href='https://www.cpeos.org.cn/personal/login/business?url='+window.location.href;
          location.href = window.dataManage.tianhuiLoginUrl + '?url=' + window.location.href;



        }
      }).catch(err => {
        console.log(err);
      })
    }
  } else {
    next();
  }


});

router.afterEach((to, from) => { //这里不接收next
  // console.log(to.path)
  // 当跳入tab主页时 赋值选中tab
  if (to.path == '/' || to.path == '/RemoteSensingMall' || to.path == '/TradingHall' || to.path == '/newsInfo' || to.path == '/remoteSensingpedia' || to.path == '/aboutUS' || to.path == '/moonSample'
    || to.path == '/ResourceTools' || to.path == '/PDSINDEX') {
    store.commit("setActive", to.path)
  }

  // 解决bug：页面/路由跳转后，滚动条消失，页面无法滚动

  document.querySelector("body").setAttribute("style", "overflow: auto !important;")
})

/* 由于Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理。
vue-router先报了一个Uncaught(in promise)的错误(因为push没加回调) ，然后再点击路由的时候才会触发NavigationDuplicated的错误(路由出现的错误，全局错误处理打印了出来)。*/
// 禁止全局路由错误处理打印
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default router